import IntlMessageFormat from 'intl-messageformat';
import '@formatjs/intl-pluralrules/polyfill-locales';

export default (message, locales) => new IntlMessageFormat(message, locales);
